export default __webpack_public_path__ + "static/media/search-icon.fe8d205f.svg";